import { request } from '../request';

export const fetchGetAccountList = (params?: Api.SystemManage.AccountParams) => {
  return request<Api.SystemManage.AccountList>({
    url: '/developer-platform/api/account/query/list',
    method: 'get',
    params
  });
};

export const fetchPostAccountAdd = (data: Api.SystemManage.AddAccount) => {
  return request({
    url: '/developer-platform/api/account/add',
    method: 'post',
    data
  });
};

/**
 * 添加账号V2
 * @param data
 * @returns
 */
export const fetchPostAccountAddV2 = (data: Api.SystemManage.AddAccount) => {
  return request<Api.SystemManage.AddAccountSuccess>({
    url: '/developer-platform/api/account/addV2',
    method: 'post',
    data
  });
};

/**
 * 同步账号
 * @param userId
 * @returns
 */
export const fectchGetAccountPull = (userId: string) => {
  return request({
    url: '/developer-platform/api/account/add/pull',
    method: 'get',
    params: {
      userId
    }
  });
}

export const fetchPostAccountUpdate = (data: Api.SystemManage.UpdateAccount) => {
  return request({
    url: '/developer-platform/api/account/update',
    method: 'post',
    data
  });
};

export const fetchPostAccountCancel = (userId: string) => {
  return request({
    url: '/developer-platform/api/account/cancel',
    method: 'post',
    params: {
      userId
    }
  });
};

export const fetchGetAccountPermission = (userId: string) => {
  return request<Api.SystemManage.Permission>({
    url: '/developer-platform/api/account/permission/get',
    method: 'get',
    params: {
      userId
    }
  });
};

export const fetchPostAccountPermission = data => {
  return request({
    url: '/developer-platform/api/account/permission/set',
    method: 'post',
    data
  });
};

export const fetchPostResetPassword = (userId: string) => {
  return request({
    url: '/developer-platform/api/account/password/reset',
    method: 'post',
    params: {
      userId
    }
  });
};

export const fetchGetRoleList = (params?: Api.SystemManage.RoleParams) => {
  return request<Api.SystemManage.RoleList>({
    url: '/developer-platform/api/role/query/list',
    method: 'get',
    params
  });
};

export const fetchGetUserTree = () => {
  return request<Api.SystemManage.RoleMenuList>({
    url: '/developer-platform/api/menu/user/tree',
    method: 'get'
  });
};

export const fetchPostRoleAdd = data => {
  return request({
    url: '/developer-platform/api/role/add',
    method: 'post',
    data
  });
};

export const fetchPostRoleDelete = (roleId: string) => {
  return request({
    url: '/developer-platform/api/role/remove',
    method: 'post',
    params: {
      roleId
    }
  });
};

export const fetchGetRoleTree = (roleId: string) => {
  return request({
    url: '/developer-platform/api/menu/role/tree',
    method: 'get',
    params: {
      roleId
    }
  });
};

export const fetchGetRoleDetail = (roleId: string) => {
  return request({
    url: '/developer-platform/api/role/query/detail',
    method: 'get',
    params: {
      roleId
    }
  });
};

export const fetchPostRoleUpdate = data => {
  return request({
    url: '/developer-platform/api/role/update',
    method: 'post',
    data
  });
};

export const fetchGetMenuList = () => {
  return request({
    url: '/developer-platform/api/menu/tree',
    method: 'get'
  });
};

export const fetchPostMenuAdd = (data: Api.SystemManage.RouteMenu) => {
  return request({
    url: '/developer-platform/api/menu/add',
    method: 'post',
    data
  });
};

export const fetchPostMenuDelete = (menuId: number) => {
  return request({
    url: '/developer-platform/api/menu/remove',
    method: 'post',
    params: {
      menuId
    }
  });
};

export const fetchPostMenuUpdate = data => {
  return request({
    url: '/developer-platform/api/menu/update',
    method: 'post',
    data
  });
};

export const fetchPostSetLang = (data: Api.SystemManage.LangList) => {
  return request({
    url: '/developer-platform/api/language/set',
    method: 'post',
    data
  });
};

export const fetchGetSetLang = () => {
  return request({
    url: '/developer-platform/api/language/get',
    method: 'get'
  });
};
export const fetchPostSetMenuLang = (data: Api.SystemManage.MenuLangList) => {
  return request({
    url: '/developer-platform/api/i18n/dp/menu/set',
    method: 'post',
    data
  });
};

export const fetchGetMenuLangInfo = () => {
  return request({
    url: '/developer-platform/api/i18n/dp/menu/info',
    method: 'get'
  });
};

export const fetchGetMenuLangExport = () => {
  return request({
    url: '/developer-platform/api/i18n/dp/menu/export',
    method: 'get',
    responseType: 'blob'
  });
};

export const fetchPostMenuLangImport = (data: any) => {
  return request({
    url: '/developer-platform/api/i18n/dp/menu/import',
    method: 'post',
    data
  });
};

export const fetchGetProductLangInfo = () => {
  return request({
    url: '/developer-platform/api/i18n/dp/product/info',
    method: 'get'
  });
};

export const fetchGetCategoryLangInfo = (params: Api.SystemManage.CategoryLangList) => {
  return request({
    url: '/developer-platform/api/i18n/dp/category/info',
    method: 'get',
    params
  });
};

export const fetchPostCategoryLangSet = (data: Api.SystemManage.CategoryLang) => {
  return request({
    url: '/developer-platform/api/i18n/dp/category/set',
    method: 'post',
    data
  });
};

export const fetchGetCategoryLangExport = (params: any) => {
  return request({
    url: '/developer-platform/api/i18n/dp/category/export',
    method: 'get',
    responseType: 'blob',
    params
  });
};


export const fetchPostCategoryLangImport = (data: any) => {
  return request({
    url: '/developer-platform/api/i18n/dp/category/import',
    method: 'post',
    data
  });
};
